module.exports = "<div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/maneuver/announce/templates/index.html
// module id = 1577
// module chunks = 0